<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            v-bind:href="'#t1' + rowData.ordcolId + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Redespachos
              <i class="fa fa-car"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade in active show"
          v-bind:id="'t1' + rowData.ordcolId + ''"
          v-if="rowData.redespachos.length > 0"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Nome</th>
                <th style="width: 5%">CNPJ</th>
                <th style="width: 5%">Vlr. Total NF</th>
                <th style="width: 5%">Peso Bruto</th>
                <th style="width: 5%">Qtde. Nfs</th>
                <th style="width: 5%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-if="rowData.redespachos.length > 0"
                v-for="(item, i) in rowData.redespachos"
              >
                <tr class="bg-gray-light" style="display: table-row">
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ item.nome }}
                    </span>
                  </td>
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ item.cnpj }}
                    </span>
                  </td>
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ formatNumber(item.vlrTotalNfs) }}
                    </span>
                  </td>
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ formatNumber(item.pesoBruto) }}
                    </span>
                  </td>
                  <td>
                    <span v-b-tooltip.hover.rightbottom>
                      {{ item.qtdNfs }}
                    </span>
                  </td>
                  <td>
                    <a
                      @click="onDetail(item.cnpj)"
                      v-b-tooltip
                      title="Ver detalhes"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="isVisibleDetailRow(item.cnpj)">
                  <td colspan="15">
                    <section class="tabs-section">
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                          v-bind:id="'tr9' + item.carbipdocId + ''"
                        >
                          <table
                            :class="[
                              'vuetable table table-striped tbl-typical',
                            ]"
                          >
                            <thead>
                              <tr>
                                <th style="width: 5%">N. Fiscal</th>
                                <th style="width: 5%">Valor NF</th>
                                <th style="width: 5%">Dt emissão NF</th>
                                <th style="width: 5%">Dt previsão NF</th>
                                <th style="width: 5%">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template
                                v-if="item.notas.length > 0"
                                v-for="(item2, i2) in item.notas"
                              >
                                <tr
                                  class="bg-gray-light"
                                  style="display: table-row"
                                >
                                  <td>
                                    <span
                                      v-b-tooltip.hover.rightbottom
                                      :title="'Chave : ' + item2.chave"
                                    >
                                      {{ item2.numFiscal }}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      v-b-tooltip.hover.rightbottom
                                      :title="'Id trn : ' + item2.pessoaIdTrn"
                                    >
                                      {{
                                        formatNumber(item2.docFiscalVlrTotal)
                                      }}
                                    </span>
                                  </td>
                                  <td>
                                    {{ formatDate(item2.dtEmi) }}
                                  </td>
                                  <td>
                                    {{ formatDate(item2.dtPrevisao) }}
                                  </td>
                                  <td>
                                    <a
                                      @click="onDetail(item2.docfisId)"
                                      v-b-tooltip
                                      title="Ver detalhes"
                                      ><i class="fa fa-plus"></i
                                    ></a>
                                  </td>
                                </tr>
                                <tr v-if="isVisibleDetailRow(item2.docfisId)">
                                  <td colspan="15">
                                    <section class="tabs-section">
                                      <ul
                                        class="nav nav-tabs nav-topline nav-justified"
                                        role="tablist"
                                      >
                                        <li class="nav-item">
                                          <a
                                            class="nav-link active"
                                            v-bind:href="
                                              '#tr1' + item2.docfisId + ''
                                            "
                                            role="tab"
                                            data-toggle="tab"
                                          >
                                            <span class="nav-link-in">
                                              Partes Env.
                                              <i class="fa fa-map-marker"></i>
                                            </span>
                                          </a>
                                        </li>
                                        <li class="nav-item">
                                          <a
                                            class="nav-link"
                                            v-bind:href="
                                              '#tr2' + item2.docfisId + ''
                                            "
                                            role="tab"
                                            data-toggle="tab"
                                          >
                                            <span class="nav-link-in">
                                              Ocorrências
                                              <i class="fa fa-map-marker"></i>
                                            </span>
                                          </a>
                                        </li>
                                      </ul>
                                      <div class="tab-content">
                                        <div
                                          role="tabpanel"
                                          class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                                          v-bind:id="
                                            'tr1' + item2.docfisId + ''
                                          "
                                        >
                                          <table
                                            :class="[
                                              'vuetable table table-striped tbl-typical',
                                            ]"
                                          >
                                            <thead>
                                              <tr>
                                                <th style="width: 10%"></th>
                                                <th style="width: 10%">
                                                  CNPJ / CPF
                                                </th>
                                                <th style="width: 10%">IE</th>
                                                <th style="width: 10%">Nome</th>
                                                <th style="width: 10%">
                                                  Município
                                                </th>
                                                <th style="width: 3%">
                                                  Estado
                                                </th>
                                                <th style="width: 15%">
                                                  Endereço
                                                </th>
                                                <th style="width: 12%">
                                                  Bairro
                                                </th>
                                                <th style="width: 10%">CEP</th>
                                                <th style="width: 10%">
                                                  Email
                                                </th>
                                                <th style="width: 5%">
                                                  Telefone
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv
                                                    .emiEndereco
                                                "
                                              >
                                                <td>
                                                  <span
                                                    class="badge badge-primary"
                                                    >Emitente</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .emiCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .emiCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiIe
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiUf
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .emiCep
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .emiEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .emiTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .emiTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv
                                                    .remEndereco
                                                "
                                              >
                                                <td>
                                                  <span
                                                    class="badge badge-warning"
                                                    >Remetente</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .remCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .remCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remIe
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remUf
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .remCep
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .remEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .remTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .remTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv
                                                    .expEndereco
                                                "
                                              >
                                                <td>
                                                  <span class="badge badge-info"
                                                    >Expedidor</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .expCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .expCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expIe
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expUf
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .expCep
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .expEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .expTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .expTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv
                                                    .desEndereco
                                                "
                                              >
                                                <td>
                                                  <span
                                                    class="badge badge-success"
                                                    >Destinatário</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .desCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .desCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desIe
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desUf
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .desCep
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .desEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .desTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .desTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                              >
                                                <td>
                                                  <span
                                                    class="badge badge-secondary"
                                                    >Recebedor</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .redCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .redCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redIe
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redUf
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .redCep
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .redEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .redTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .redTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>

                                            <tbody>
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                                v-if="
                                                  item2.docFiscalPartesEnv
                                                    .tomEndereco
                                                "
                                              >
                                                <td>
                                                  <span
                                                    class="badge badge-primary"
                                                    >Tomador</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomCnpj != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .tomCnpj
                                                      )
                                                    }}
                                                  </span>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomCpf != null
                                                    "
                                                  >
                                                    {{
                                                      ajustaMascara(
                                                        item2.docFiscalPartesEnv
                                                          .tomCpf
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomIe
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomNome
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomNomeMunicipio
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomUf
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomEndereco
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomComplemento
                                                  }}
                                                  -
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomNumero
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomBairro
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    item2.docFiscalPartesEnv
                                                      .tomCep
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomEmail
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .tomEmail
                                                    }}</span
                                                  >
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item2.docFiscalPartesEnv
                                                        .tomTelefone
                                                    "
                                                    >{{
                                                      item2.docFiscalPartesEnv
                                                        .tomTelefone
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>

                                        <div
                                          role="tabpanel"
                                          class="tab-pane fade in pt-1 border-color-detalhes-grey"
                                          v-bind:id="
                                            'tr2' + item2.docfisId + ''
                                          "
                                        >
                                          <table
                                            :class="[
                                              'vuetable table table-striped tbl-typical',
                                            ]"
                                          >
                                            <thead>
                                              <tr>
                                                <th style="width: 10%">Tipo</th>
                                                <th style="width: 10%">
                                                  Ocorrência
                                                </th>
                                                <th style="width: 10%">
                                                  Data Ocorrência
                                                </th>
                                                <th style="width: 10%">
                                                  N ° Docmento
                                                </th>
                                                <th style="width: 10%">
                                                  Série
                                                </th>
                                                <th style="width: 10%">
                                                  Dt Emissão
                                                </th>
                                                <th style="width: 10%">
                                                  N ° Fiscal
                                                </th>
                                                <th style="width: 10%">
                                                  Série
                                                </th>
                                                <th style="width: 10%">
                                                  Dt Emissão
                                                </th>
                                                <th style="width: 10%">
                                                  Status
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody
                                              v-for="item_ocorrencia in item2.cargaOcorrencia"
                                            >
                                              <tr
                                                class="bg-gray-light"
                                                style="display: table-row"
                                              >
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docfisId !==
                                                      null
                                                    "
                                                    class="badge badge-primary"
                                                    >Documento</span
                                                  >
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.pedunicarId !==
                                                      null
                                                    "
                                                    class="badge badge-warning"
                                                    >Unidade Carga</span
                                                  >
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.peduncatrId !==
                                                      null
                                                    "
                                                    class="badge badge-danger"
                                                    >Trecho</span
                                                  >
                                                </td>
                                                <td>
                                                  {{
                                                    item_ocorrencia
                                                      .paramOcorrencia.descr
                                                  }}
                                                </td>
                                                <td>
                                                  {{
                                                    formatDate(
                                                      item_ocorrencia.dtOcorrencia
                                                    )
                                                  }}
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docNumFiscal !=
                                                      null
                                                    "
                                                  >
                                                    {{
                                                      item_ocorrencia.docNumFiscal
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docSerie !=
                                                      null
                                                    "
                                                  >
                                                    {{
                                                      item_ocorrencia.docSerie
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docDtEmi !=
                                                      null
                                                    "
                                                  >
                                                    {{
                                                      formatDate(
                                                        item_ocorrencia.docDtEmi
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docFiscalNumFiscal !=
                                                      null
                                                    "
                                                  >
                                                    {{
                                                      item_ocorrencia.docFiscalNumFiscal
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docSerie !=
                                                      null
                                                    "
                                                  >
                                                    {{
                                                      item_ocorrencia.docSerie
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    v-if="
                                                      item_ocorrencia.docFiscalDtEmi !=
                                                      null
                                                    "
                                                  >
                                                    {{
                                                      formatDate(
                                                        item_ocorrencia.docFiscalDtEmi
                                                      )
                                                    }}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    class="badge badge-success"
                                                    v-if="
                                                      item_ocorrencia.status
                                                        .valor == 1
                                                    "
                                                    >{{
                                                      item_ocorrencia.status
                                                        .descr
                                                    }}</span
                                                  >
                                                  <span
                                                    class="badge badge-danger"
                                                    v-if="
                                                      item_ocorrencia.status
                                                        .valor == 2
                                                    "
                                                    >{{
                                                      item_ocorrencia.status
                                                        .descr
                                                    }}</span
                                                  >
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </section>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </section>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accounting from "accounting";
import moment from "moment";

export default {
  data() {
    return {
      visibleDetailRows: [],
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    showDetailRow(rowId) {
      if (!this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetailRow(rowId) {
      if (this.isVisibleDetailRow(rowId)) {
        this.hideDetailRow(rowId);
      } else {
        this.showDetailRow(rowId);
      }
    },
    onDetail(id) {
      this.toggleDetailRow(id);
    },
    isVisibleDetailRow(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    formatDateHora(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm:ss").format(fmt);
    },
  },
};
</script>
